import React from 'react';

import QuickAddAthlete from './quickAddAthlete/QuickAddAthlete';

import PersonGeneralContextProvider from '@usas/ui-web/state/personGeneral/PersonGeneralContextProvider';
import OrgUnitAthleteContextProvider from '@usas/ui-web/state/orgUnitAthlete/OrgUnitAthleteContextProvider';

const QuickAdd = () => (
  <PersonGeneralContextProvider>
    <OrgUnitAthleteContextProvider>
      <QuickAddAthlete />
    </OrgUnitAthleteContextProvider>
  </PersonGeneralContextProvider>
);

export default QuickAdd;